import gql from 'graphql-tag';

const pendingVRAMutation = gql`
  mutation pendingVra($input: PendingVraInput!) {
    pendingVra(input: $input) {
      clientMutationId
      data
      errors
      msg
      notice
      success
    }
  }
`;

export default pendingVRAMutation;
